
import Vue from 'vue';
import getItemFromObject from 'lodash/get';
import { DataWithHref } from '@root/modules/headlines/types/headlines';
import { HeadlineLabel } from '@headlines/types/headline';
import { HeadlineLabels, HeadlineTitle, HeadlineImage, HeadlineLead } from '@headlines/components/fragments';
import categoryUrl from '@root/modules/category/utils/buildCategoryUrl';

interface Data {
  leadLimit: number;
}

interface Props {
  headline: DataWithHref;
  pictureSrcset: Record<string, unknown>;
  template: string;
}

interface Computed {
  ptContent: boolean;
}

interface Methods {
  labels: (headline: DataWithHref) => (HeadlineLabel | undefined)[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    HeadlineLabels,
    HeadlineImage,
    HeadlineTitle,
    HeadlineLead,
  },
  props: {
    headline: {
      type: Object,
      required: true,
    },
    pictureSrcset: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    template: {
      type: String,
      required: false,
      default: () => 'horizontal',
    },
  },
  data() {
    return {
      leadLimit: 140,
    };
  },
  computed: {
    ptContent() {
      return !!(this.headline.settings && this.headline.settings.find((setting) => setting.key === 'icon.reklama')?.value);
    },
  },
  methods: {
    labels(headline) {
      const labels = [];

      const { domain } = this.$channelConfig('settings');
      const sameChannel = domain === headline.primaryCategory.channel.url;
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;

      if (
        !sameChannel &&
        headline.primaryCategory?.channel.url !== 'www.delfi.lt' &&
        headline.primaryCategory?.channel.url !== 'www.delfi.lt/projektai' &&
        headline.primaryCategory?.channel.url !== 'www.delfi.lt/uzsakomasis-turinys'
      ) {
        labels.push({
          title: getItemFromObject(headline, 'primaryCategory.channel.name'),
          href: `/${headline.primaryCategory.channel.path || ''}`,
        });
      } else {
        labels.push({
          title: getItemFromObject(headline, 'primaryCategory.name'),
          href: categoryUrl({ category: headline.primaryCategory, domain, fakeDomainEnabled }),
        });
      }

      return labels;
    },
  },
});
